import axios from 'axios'


/**
 *
 * @status no delete (needed for notification service when implemented)
 * @class NotificationSocket
 */
class NotificationSocket {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    async getNotificationSocket(userId, timezone, token) {
        let response = await axios.get(`${this.apiUrl}/notifications-socket?userId=${userId}&timezone=${encodeURIComponent(timezone)}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data.data
    }

    async updateNotificationSocket(notificationActionId, notificationId, notificationParams, token) {
        let response = await axios.post(
            `${this.apiUrl}/notification-engine`,
            {
                notificationActionId,
                notificationId,
                notificationParams
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    }
}

export { NotificationSocket as default } 